import type {
  IUpdateCampaignState,
  IUpdateCampaignInfo,
  ICreateCampaign,
  IDeleteCampaign,
  IUpdateCampaign,
  ICreateCampaignDraft,
} from '~/modules/campaign';
import type { Campaign } from '~/types/graphql';

import {
  useCreateCampaignDraft,
  useUpdateCampaignState,
  useUpdateCampaignInfo,
  useCreateCampaign,
  useDeleteCampaign,
  useUpdateCampaign,
} from '~/modules/campaign';

export interface IHandleCampaign<T extends Campaign>
  extends
    ICreateCampaign<T>,
    IDeleteCampaign<T>,
    IUpdateCampaignState<T>,
    IUpdateCampaignInfo<T>,
    ICreateCampaignDraft<T>,
    IUpdateCampaign<T> {}

export const useHandleCampaign = <T extends Campaign>(): IHandleCampaign<T> => {
  const { isLoadingUpdate, onUpdateCampaign } = useUpdateCampaign<T>();
  const { isLoadingDelete, onDeleteCampaign } = useDeleteCampaign<T>();
  const { isLoadingUpdateState, onUpdateCampaignState } = useUpdateCampaignState<T>();
  const { isLoadingCreate, onCreateCampaignDraft } = useCreateCampaignDraft<T>();
  const { onCreateCampaign } = useCreateCampaign<T>();
  const { onUpdateCampaignInfo } = useUpdateCampaignInfo<T>();

  return {
    isLoadingCreate,
    isLoadingUpdate,
    isLoadingDelete,
    isLoadingUpdateState,
    onCreateCampaign,
    onUpdateCampaign,
    onDeleteCampaign,
    onUpdateCampaignState,
    onUpdateCampaignInfo,
    onCreateCampaignDraft,
  };
};
